var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BulkContractServiceFeeEditor",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              resourceTitle: _vm._f("pgettext")(
                "Contract Service Fees",
                "BulkContractServiceFeeEditor|ResourceTitle"
              ),
              resourceKey: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "valid_from",
                        label: _vm._f("gettext")("Valid From"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "valid_from_enabled" },
                              model: {
                                value: _vm.item.$updates.valid_from,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "valid_from", $$v)
                                },
                                expression: "item.$updates.valid_from"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "valid_from",
                          disabled: !_vm.item.$updates.valid_from
                        },
                        model: {
                          value: _vm.item.valid_from,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "valid_from", $$v)
                          },
                          expression: "item.valid_from"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "valid_to",
                        label: _vm._f("gettext")("Valid To"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "valid_to_enabled" },
                              model: {
                                value: _vm.item.$updates.valid_to,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "valid_to", $$v)
                                },
                                expression: "item.$updates.valid_to"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "valid_to",
                          disabled: !_vm.item.$updates.valid_to
                        },
                        model: {
                          value: _vm.item.valid_to,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "valid_to", $$v)
                          },
                          expression: "item.valid_to"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "amount",
                        label: _vm._f("pgettext")(
                          "Amount",
                          "ContractServiceFee"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "amount_enabled" },
                              model: {
                                value: _vm.item.$updates.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "amount", $$v)
                                },
                                expression: "item.$updates.amount"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormInput", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "amount",
                          disabled: !_vm.item.$updates.amount,
                          mask: "number",
                          unmask: "typed",
                          scale: "4"
                        },
                        model: {
                          value: _vm.item.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "amount", $$v)
                          },
                          expression: "item.amount"
                        }
                      }),
                      _vm._v(" "),
                      _c("ItpFormSelect", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "currency",
                          options: _vm.currencies,
                          disabled: !_vm.item.$updates.amount,
                          textField: "code",
                          valueField: "code"
                        },
                        model: {
                          value: _vm.item.currency,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "currency", $$v)
                          },
                          expression: "item.currency"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "quantity",
                        label: _vm._f("gettext")("Quantity"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "quantity_enabled" },
                              model: {
                                value: _vm.item.$updates.quantity,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "quantity", $$v)
                                },
                                expression: "item.$updates.quantity"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormInput", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "quantity",
                          disabled: !_vm.item.$updates.quantity
                        },
                        model: {
                          value: _vm.item.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "quantity", $$v)
                          },
                          expression: "item.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "unit_of_quantity",
                        label: _vm._f("pgettext")(
                          "Unit of quantity",
                          "ContractServiceFee"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "unit_of_quantity_enabled" },
                              model: {
                                value: _vm.item.$updates.unit_of_quantity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "unit_of_quantity",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.unit_of_quantity"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormInput", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "unit_of_quantity",
                          disabled: !_vm.item.$updates.unit_of_quantity
                        },
                        model: {
                          value: _vm.item.unit_of_quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "unit_of_quantity", $$v)
                          },
                          expression: "item.unit_of_quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "inflation_indexed",
                        label: _vm._f("pgettext")(
                          "Inflation indexed",
                          "ContractServiceFee"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "inflation_indexed_enabled" },
                              model: {
                                value: _vm.item.$updates.inflation_indexed,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "inflation_indexed",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.inflation_indexed"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormCheckbox", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "inflation_indexed",
                          disabled: !_vm.item.$updates.inflation_indexed
                        },
                        model: {
                          value: _vm.item.inflation_indexed,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "inflation_indexed", $$v)
                          },
                          expression: "item.inflation_indexed"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "transaction_notes",
                        label: _vm._f("pgettext")(
                          "Transaction notes",
                          "ContractServiceFee"
                        ),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "transaction_notes_enabled" },
                              model: {
                                value: _vm.item.$updates.transaction_notes,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "transaction_notes",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.transaction_notes"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("TransactionNotesEditor", {
                        staticClass: "w-auto",
                        attrs: {
                          type: "number",
                          name: "transaction_notes",
                          disabled: !_vm.item.$updates.transaction_notes
                        },
                        model: {
                          value: _vm.item.transaction_notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "transaction_notes", $$v)
                          },
                          expression: "item.transaction_notes"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      staticClass: "col",
                      attrs: {
                        name: "notes",
                        label: _vm._f("pgettext")("Notes", "Invoice"),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "notes_enabled" },
                              model: {
                                value: _vm.item.$updates.notes,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "notes", $$v)
                                },
                                expression: "item.$updates.notes"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormTextarea", {
                        attrs: {
                          name: "notes",
                          disabled: !_vm.item.$updates.notes
                        },
                        model: {
                          value: _vm.item.notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "notes", $$v)
                          },
                          expression: "item.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }